<!--
 * @Author: Tang Yuxuan
 * @Date: 2020-10-12 09:43:02
 * @LastEditTime: 2020-10-22 14:50:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \writing_pc\src\components\writing\ideas.vue
-->
<!-- 推荐思路 -->
<template>
  <div class="ideas">
    <div class="non404" v-if="listData.length == 0">
      <div v-if="content != ''">
        <img
          class="userimg"
          src="/static/images/non404_huanxieyiduan.png"
          alt=""
          srcset=""
        />
        <p>建议换一章或换一段写</p>
      </div>
      <div v-if="content == ''" class="non404_content">
        <p><span class="order-circle">1</span>点击左侧<span style="font-weight:800">正文</span>中需要续写的地方</p>
        <img
          class="non404_pointer"
          src="/static/images/non404_pointer.png"
          alt=""
          srcset=""
        />
        <!-- <p>点击论文正文，查看推荐思路</p> -->
        <p><span class="order-circle">2</span>点击光标附近的"推荐思路"按钮即可查看对应思路</p>
      </div>
    </div>

    <div class="list" v-if="listData.length != 0">
      <div class="listrow" v-for="(item, index) in listData" :key="index">
        <p>{{ item.content }}</p>
        <div class="tag_btn">
          <div class="tag_box">
            <span v-for="(items, i) in item.keywords" :key="i">{{
              items
            }}</span>
          </div>
          <div style="display:flex">
            <button class="copy" @click="copyToClipBoard(item.content)">
              复制文本</button
            ><button class="push" @click="addhtml(item.content)">
              导入文中
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="btn_box" v-if="listData.length != 0">
      <button class="get_ideas" @click="get_ideas()">换一换</button>
    </div>

    <div class="limit-open-vip">
      <el-dialog 
       :close-on-click-modal= "false"
        :visible.sync="opneVipVisible"
        width="500px"
        top="30vh"
        title="导入论文">
        <div class="open-vip-box">
          <div class="open-vip-box-message">今日2次导入机会已用完，开通会员继续享受</div>
          <button
              @click="goVip"
              class="check-glod-btn"
              style="margin-right:16px"
            >
              <span class="check-btn-text">开通会员</span>
            </button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  props: ["content", "listData"],
  data: function() {
    return {
      importTimes: 0,
      opneVipVisible: false
    };
  },
  components: {},
  created: function() {
    this.getImportTimes();
  },
  mounted: function() {},
  methods: {
    get_ideas: function() {
      this.$emit("get_ideas", "true");
    },
    addhtml: function(data) {
      this.api.getToolsLimitCheck({type:4}).then(res=> {
        if( res.code == 0) {
           this.$emit("addhtml", data);
        } else {
          this.opneVipVisible = true;
        }
      })
    },

    // 校验导入原文的次数 (这个地方用次数表示，没有用true 或false表示，主要是考虑后期提示的次数是否需要从后台读取的可配置数据)
    validateImportTimes: function() {
      let _this = this;
      this.api
        .getToolsLimitCheck({
          type: 4
        })
        .then(res => {
          if (res.code == 0) {
            this.importTimes = 1;
          } else {
            this.opneVipVisible = true
          }
        });
    },

    copyToClipBoard: function(val) {
      var save = function(e) {
        e.clipboardData.setData("text/plain", val);
        e.preventDefault();
      };

      document.addEventListener("copy", save);
      document.execCommand("copy");
      document.removeEventListener("copy", save);
      let mgs = `<div style="display: flex; align-items: center;"><img src="/static/images/gou.png" style="margin-right:5px;width:14px;height:14px" alt="" srcset="" /> 复制成功</div>`;
      this.$message({
        dangerouslyUseHTMLString: true,
        iconClass: "none",
        showClose: true,
        message: mgs,
        customClass: "mymessage",
        duration: 1000
      });
    },
    /** 获取导入次数 */
    getImportTimes() {
        this.api.getToolsLimitCheck({
          type: 3
        }).then(res => {
            if (res.code == 0) {
                this.importTimes = 1;
            } else{
                this.importTimes = 0;
            }
        })
    },

    goVip() {
      this.opneVipVisible = false;
      this.$parent.goVip();
    }
  }
};
</script>

<style lang="scss" scoped>
.ideas {
  .non404 {
    text-align: center;
    margin-top: 300px;

    img {
      width: 111px;
      height: 111px;
    }

    .non404_content{
        text-align: left;
        margin-top: -154px;
        padding-left: 87px;

        .non404_pointer{
            width: 451px;
            height: 290px;
        }

        .order-circle{
            display: inline-block;
            width: 24px;
            height: 24px;
            line-height: 24px;
            margin-right: 10px;
            margin-left: -11px;
            text-align: center;
            background: #66686E;
            color: #ffffff;
            border: 1px solid #707070;
            border-radius: 50%;
            opacity: 1;
        }

        p {
            margin-top: 0;
        }
    }

    

    p {
      margin-top: 38px;
      font-size: 14px;
      color: #66686e;
    }
  }

  .list {
    height: calc(100vh - 150px);
    width: calc(100% - 80px);
    overflow: auto;
    padding: 0 40px;

    .listrow {
      border-bottom: 1px solid #f5f6fa;
      padding-bottom: 16px;
      margin-top: 30px;

      p {
        font-size: 14px;
        color: #66686e;
        line-height: 24px;
        margin-bottom: 15px;
      }

      .tag_btn {
        display: flex;
        justify-content: space-between;
      }

      .tag_box {
        span {
          display: inline-block;
          padding: 7px 12px;
          color: #989ea2;
          background: #f5f6fa;
          height: 13px;
          border-radius: 13px;
          line-height: 13px;
          margin-right: 8px;
          margin-bottom: 10px;
        }
      }

      .copy {
        color: $btnc;
        border-radius: 20px;
        background: none;
        height: 26px;
        min-width: 80px;
      }

      .push {
        border-radius: 20px;
        background: $btnc;
        color: #ffffff;
        margin-left: 16px;
        height: 26px;
        min-width: 80px;
      }
    }
  }

  .btn_box {
    height: 96px;
    line-height: 96px;
    text-align: center;

    .get_ideas {
      width: 240px;
      height: 36px;
      background: linear-gradient(0deg, #5676bd 0%, #6687c8 100%);
      border-radius: 18px;
      color: #ffffff;
    }
  }

  .limit-open-vip {
   /deep/ .el-dialog__title{
     font-weight: bold;
   }
 }

   .open-vip-box{
    display:flex;
    flex-direction: column;
    align-items:center;
    justify-content:space-between;

    .open-vip-box-message{
      margin-bottom: 20px;
    }

    .check-glod-btn {
      width: 134px;
      height: 36px;
      background: #c79758;
      opacity: 1;
      border-radius: 18px;
      border: none;
    }
    .check-btn-text {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 12px;
      color: #ffffff;
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/writing/ideas.vue